import { SurveyComponent, Survey } from "@tree-company/tree-query";
import { useContext, useEffect, useMemo } from "react";
import { Navigate, useParams } from "react-router-dom";
import { surveySettingsForStatement } from "../surveys";
import { STATEMENT_KEYS, STATEMENTS } from "../statements";
import { LocaleContext } from "../components/localization_wrapper";

// We create a small wrapper component so that we are sure that the statement exists when we render `StatementSurvey`
//
export function StatementSurveyWrapper({ apiClient }) {
  const { statement, locale } = useParams();

  useEffect(() => {
    // This mimics the way the statement is set in the embed
    document.querySelector("#root").setAttribute("data-statement", statement);
  }, [statement]);

  // We work around the name of the page in bpart vs our local env
  if (Object.values(STATEMENTS).find((s) => s.bpart_path === statement)) {
    const [key] = Object.entries(STATEMENTS).find(
      ([, s]) => s.bpart_path === statement,
    );
    return <Navigate to={`/${locale}/${key}`} />;
  }

  // Redirect back to root if the user went to a url that doesn't exist
  if (!STATEMENT_KEYS.includes(statement)) {
    return <Navigate to={`/${locale}`} />;
  }

  return <StatementSurvey apiClient={apiClient} statement={statement} />;
}

export function StatementSurvey({ apiClient, statement }) {
  const i18n = useContext(LocaleContext);

  const treesponse = useMemo(() => {
    return apiClient.initTreesponse({
      language: i18n.locale,
      surveyVersion: "v2",
      initialAnswers: { statement },
    });
  }, [statement]);

  const survey = useMemo(() => {
    const survey = new Survey(
      surveySettingsForStatement(statement, i18n),
      treesponse,
    );
    // If we are on the "like" page and there are only two comments, redirect to next page.
    survey.settings.pages
      .find((page) => page.key === "like")
      .sections.find((section) => section.key === "like").onOptionsLoaded = (
      options,
    ) => {
      if (options.length < 2) {
        survey.nextPage();
      }
    };

    return survey;
  }, [statement]);

  return <SurveyComponent survey={survey} />;
}
